import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from './Logo';

const Header = () => {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: 'INÍCIO' },
    { path: '/fashion-film', label: 'FASHION FILM' },
    { path: '/rede-social', label: 'REDE SOCIAL' },
    { path: '/comercial', label: 'COMERCIAL E OUTROS' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header
      style={{
        backgroundColor: scrolled ? 'rgba(247, 245, 239, 0.97)' : '#f7f5ef',
        backdropFilter: scrolled ? 'blur(8px)' : 'none',
        transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
        boxShadow: scrolled ? '0 1px 20px rgba(0,0,0,0.06)' : 'none',
        position: 'sticky',
        top: 0,
        zIndex: 100,
        paddingTop: '2rem',
        paddingBottom: '1.5rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        borderBottom: '1px solid rgba(0,0,0,0.04)',
      }}
    >
      {/* Title with paper clip decoration */}
      <div style={{ position: 'relative', display: 'inline-block', marginBottom: '0.4rem' }}>
        {/* Paper clip SVG */}
        <svg
          style={{ position: 'absolute', top: '-22px', right: '-30px', opacity: 0.5, transform: 'rotate(14deg)' }}
          width="20" height="42" viewBox="0 0 24 48" fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M12 4C8.69 4 6 6.69 6 10V38C6 41.31 8.69 44 12 44C15.31 44 18 41.31 18 38V14C18 12.34 16.66 11 15 11C13.34 11 12 12.34 12 14V36" stroke="#8a7560" strokeWidth="2.2" strokeLinecap="round" fill="none"/>
        </svg>

        <Link to="/" style={{ textDecoration: 'none', color: '#1a1a1a', display: 'block' }}>
          <h1 style={{ margin: 0, lineHeight: 0 }}>
            <Logo variante="horizontal" style={{ height: 'clamp(2rem, 5vw, 3.6rem)' }} />
          </h1>
        </Link>
      </div>

      <p
        style={{
          fontFamily: '"Nunito", sans-serif',
          fontSize: 'clamp(8px, 1.1vw, 12px)',
          letterSpacing: '0.38em',
          color: '#7a7a7a',
          margin: '0.5rem 0 1.4rem 0',
          textTransform: 'uppercase',
          fontWeight: 400,
        }}
      >
        FILMMAKER & ESTRATEGISTA DE CONTEÚDO
      </p>

      {/* Navigation with washi tape */}
      <nav style={{ position: 'relative' }}>
        {/* Washi tape strip behind nav */}
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '-20px',
            right: '-20px',
            height: '30px',
            transform: 'translateY(-50%) rotate(-0.3deg)',
            background: 'rgba(210, 190, 150, 0.26)',
            borderRadius: '2px',
            pointerEvents: 'none',
            zIndex: 0,
          }}
        />
        <ul
          style={{
            display: 'flex',
            gap: 'clamp(0.8rem, 2.5vw, 2.2rem)',
            justifyContent: 'center',
            listStyle: 'none',
            margin: 0,
            padding: '0.45rem 1.5rem',
            position: 'relative',
            zIndex: 1,
            flexWrap: 'wrap',
          }}
        >
          {navLinks.map((link) => (
            <li key={link.path}>
              <Link
                to={link.path}
                style={{
                  fontFamily: '"Nunito", sans-serif',
                  fontSize: '10.5px',
                  letterSpacing: '0.2em',
                  color: isActive(link.path) ? '#1a1a1a' : '#777',
                  textDecoration: 'none',
                  fontWeight: isActive(link.path) ? 700 : 400,
                  paddingBottom: '2px',
                  borderBottom: isActive(link.path) ? '1.5px solid #1a1a1a' : '1.5px solid transparent',
                  transition: 'color 0.2s ease, border-bottom-color 0.2s ease',
                  textTransform: 'uppercase',
                  whiteSpace: 'nowrap',
                  display: 'inline-block',
                }}
                onMouseEnter={(e) => {
                  if (!isActive(link.path)) e.currentTarget.style.color = '#1a1a1a';
                }}
                onMouseLeave={(e) => {
                  if (!isActive(link.path)) e.currentTarget.style.color = '#777';
                }}
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
};

export default Header;
